import { render, staticRenderFns } from "./prescription.vue?vue&type=template&id=6c04b313&scoped=true&"
import script from "./prescription.vue?vue&type=script&lang=js&"
export * from "./prescription.vue?vue&type=script&lang=js&"
import style0 from "./prescription.vue?vue&type=style&index=0&id=6c04b313&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c04b313",
  null
  
)

component.options.__file = "prescription.vue"
export default component.exports